import {
  Flex, FormConfigurationProvider, ThemeType, LinkButton as LinkButtonShared,
} from '@equifinance/shared';
import { PropsWithChildren } from 'react';
import styled, { css, FlattenInterpolation, ThemeProps } from 'styled-components';
import { usePageConfigurationContext } from '../../../../../contexts/pageConfiguration';

export const Label = styled.span`${({ theme }) => `
  font-size: ${theme.fontSize[2]};
  font-weight: ${theme.fontWeight.normal};
  font-weight: ${theme.fontWeight.bold};
`}`;

export const Value = styled(Flex)`${({ theme }) => `
  font-size: ${theme.fontSize[2]};
  font-weight: ${theme.fontWeight.normal};
`}`;

export function DataInfo({ label, value }: { label: string, value: any }) {
  return value && (
    <Flex>
      <Label>
        {label}
        :&nbsp;
      </Label>
      <Value>{value}</Value>
    </Flex>
  );
}

export const RowData = styled(Flex) <{ justifyContent?: string }>`${({ theme, justifyContent }) => `
  gap: ${theme.padding[10]};
  justify-content: ${justifyContent};
`}`;

export const LinkButton = styled(LinkButtonShared)`${({ theme }) => `
  color: ${theme.colours.link[1]};
  font-size: ${theme.fontSize[2]};
  font-weight: ${theme.fontWeight.bold};
  padding: 0;
  gap: 0;
  height: unset;

  &:active {
    color: ${theme.colours.link[1]};
  };
`}`;

export function FormSectionConfigurationAdapter({ children, isSectionDisabled }: PropsWithChildren<{ isSectionDisabled: boolean }>) {
  const { isReadOnly: isPageReadOnly } = usePageConfigurationContext();
  return (
    <FormConfigurationProvider isReadOnlyInput={isPageReadOnly || isSectionDisabled}>
      {children}
    </FormConfigurationProvider>
  );
}

export const HeaderCss = css<{ level: number }>`${({ theme }) => `
  height: ${theme.collapseHeaderHeight};
  background: ${theme.colours.primary[3]};
  color: ${theme.colours.primary[1]};

  .mi-chevron-down, .mi-chevron-up {
    color: ${theme.colours.primary[10]};
  }
`}` as FlattenInterpolation<ThemeProps<ThemeType>>;

export const TitleCss = css<{ level: number }>`${({ theme }) => `
  color: ${theme.colours.neutral[10]};
`}` as FlattenInterpolation<ThemeProps<ThemeType>>;
